import React, { useEffect, useState } from "react";
import styles from "./NewsCard.module.scss";
import moment from "moment";
import InfoButton from "../../Atoms/InfoButton/InfoButton";
import moreInfo from "../../../assets/icons/programs/major/moreInfo.svg";
import editSvg from "../../../assets/icons/formActions/edit.svg";
import deleteSvg from "../../../assets/icons/formActions/delete.svg";
import { useNavigate } from "react-router-dom";
import DeletePopup from "../Custom/DeletePopup";
import NewsInfoModal from "./NewsInfoModal";
import newsUpdated from "../../../assets/Imagess/event-updated.png";
import he from "he";
import noImageFound from "../../../assets/Imagess/no-image-found.jpg";
import { useDeleteEventCountdown } from "../../../Hooks/Events";
import { useToast } from "../Custom/CustomToaster/Toast";
import { sanitizeAndValidateUrl } from "../../../app/helpers/sanitizeAndValidateUrl";

function EventCountdownCard({ event, refetchEvents }) {
  const [showInfo, setShowInfo] = useState(false);
  const navigate = useNavigate();
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [showCheckmark, setShowCheckmark] = useState(false);
  const {
    mutate: deleteEvent,
    isLoading: isDeletingEvent,
    isSuccess,
  } = useDeleteEventCountdown(event?.eventCountDownId);
  const customizedToast = useToast();
  const menuItems = [
    {
      label: 'تعديل',
      icon: editSvg,
      onClick: () => {
        navigate(`/home/edit-event-countdown/${event?.eventCountDownId}`);
      },
    },
    {
      label: 'حذف',
      icon: deleteSvg,
      onClick: () => {
        setShowDeletePopup(true);
      },
    },
  ];

  useEffect(() => {
    if (isSuccess) {
      refetchEvents();
      // setShowCheckmark(true);
      customizedToast.open('تم الحذف بنجاح');
      setTimeout(() => {
        setShowCheckmark(false);
      }, 2000);
    }
  }, [isSuccess]);

  const calculateCountdown = () => {
    const now = moment();
    const eventDate = moment(event?.eventDate);
    const duration = moment.duration(eventDate.diff(now));
    const days = Math.floor(duration.asDays());
    const hours = duration.hours();
    const minutes = duration.minutes();

    return { days, hours, minutes };
  };

  const [countdown, setCountdown] = useState(calculateCountdown());

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(calculateCountdown());
    }, 60000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className={`${styles['news-card']} ${styles['countdown-card']}`}>
      <div className={styles['countdown-image-card']}>
        <div className={styles['timer-container']}>
          <div>
            <p className={styles['time']}>{countdown.days}</p>
            <p className={styles['time-type']}>
              DAY{countdown.days !== 1 && 'S'}
            </p>
          </div>
          <p className={styles['time']}>:</p>
          <div>
            <p className={styles['time']}>{countdown.hours}</p>
            <p className={styles['time-type']}>
              HOUR{countdown.hours !== 1 && 'S'}
            </p>
          </div>
          <p className={styles['time']}>:</p>
          <div>
            <p className={styles['time']}>{countdown.minutes}</p>
            <p className={styles['time-type']}>
              MINUTE{countdown.minutes !== 1 && 'S'}
            </p>
          </div>
        </div>
        <img
          src={sanitizeAndValidateUrl(`${event?.url}${event?.eventImage}`)}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = noImageFound;
          }}
          className={styles['news-card-image']}
          // onClick={() => setShowInfo(true)}
        />
      </div>
      <div
        className={`${styles['news-card-info']} ${styles['countdown-card-info']}`}
      >
        <div className={styles['row']}>
          <p className={styles['name']}>{event?.category_EN}</p>
        </div>
        <div className={styles['row']}>
          <div className={styles['description']}>
            <p className={styles['title']}>{event?.eventNameEN}</p>
            {/* <p
              className={styles["text"]}
              dangerouslySetInnerHTML={{ __html: decodedHTML }}
            /> */}
          </div>
          <InfoButton
            icon={moreInfo}
            className={styles['more-info']}
            data={menuItems}
          />
        </div>
      </div>
      {showDeletePopup && (
        <DeletePopup
          handleOnClose={() => setShowDeletePopup(false)}
          title="حدث"
          handleDelete={() => {
            deleteEvent();
            setShowDeletePopup(false);
          }}
          isLoading={isDeletingEvent}
        />
      )}
      {showInfo && (
        <NewsInfoModal
          news={event}
          handleOnClose={() => setShowInfo(false)}
          setShowDeletePopup={setShowDeletePopup}
        />
      )}
      {showCheckmark && (
        <div className={styles['checkmark']}>
          <img src={newsUpdated} />
        </div>
      )}
    </div>
  );
}

export default EventCountdownCard;
